__turbopack_context__.v({
  "blink": "LiveNow-module-scss-module__V4sW4a__blink",
  "liveNow": "LiveNow-module-scss-module__V4sW4a__liveNow",
});
